import type {AnnotationModeState} from './AnnotationModeStore';
import type {AnnotationType, HighlightColor} from './annotationTypes';

/** The color of the annotation with `id` in `questionId`, or undefined if absent. */
export function selectHighlightColor(
  state: AnnotationModeState,
  questionId: string,
  id: string | undefined
): HighlightColor | undefined {
  if (!id) {
    return undefined;
  }
  return state.annotationsByQuestionId[questionId]?.find((annotation) => annotation.id === id)
    ?.color;
}

/** The style type of the annotation with `id` in `questionId`, or undefined if absent. */
export function selectAnnotationType(
  state: AnnotationModeState,
  questionId: string,
  id: string | undefined
): AnnotationType | undefined {
  if (!id) {
    return undefined;
  }
  return state.annotationsByQuestionId[questionId]?.find((annotation) => annotation.id === id)
    ?.type;
}
